import { APP_BASE_HREF } from '@angular/common';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-redirect-to-dashboard',
    templateUrl: './redirect-to-dashboard.component.html',
    styleUrls: ['./redirect-to-dashboard.component.scss']
})
export class RedirectToDashboardComponent implements OnInit {

    ngOnInit(): void {
        window.location.href = '/dashboard'; 
    }

}
